import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { permissionDirective, checkPermission } from './utils/permission'

import 'element-plus/dist/index.css'
const app = createApp(App)

app.directive('permission', permissionDirective)
app.config.globalProperties.$hasPerm = checkPermission

app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
  zIndex: 3000
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mount('#app')